<div class="apn">
	<div class="apn-lbl">
		Phone number to dial from <span class="apn-muted" *ngIf="!loading && !error">({{ availableCount }} of {{ phoneNumbers.length }} available)</span>
		<button type="button" class="apn-refresh" (click)="loadPhoneNumbers()" [disabled]="loading" title="Refresh">↻</button>
	</div>

	<div class="apn-muted" *ngIf="loading">Loading phone numbers…</div>
	<div class="apn-muted" *ngIf="!loading && error">Could not load phone numbers.</div>
	<div class="apn-muted" *ngIf="!loading && !error && !phoneNumbers.length">No phone numbers on the Vapi account.</div>

	<div class="apn-groups" *ngIf="!loading && !error && phoneNumbers.length">
		<div class="apn-group" *ngFor="let g of groups">
			<button type="button" class="apn-group-lbl" (click)="toggleGroup(g.state)" [attr.aria-expanded]="expanded.has(g.state)">
				<span class="apn-caret" [class.apn-caret-collapsed]="!expanded.has(g.state)">▾</span>
				{{ g.label }} <span class="apn-muted">({{ freeCount(g) }} of {{ g.numbers.length }} available)</span>
				<span class="apn-group-selected" *ngIf="!expanded.has(g.state) && hasSelected(g)">● selected</span>
			</button>
			<div class="apn-list" *ngIf="expanded.has(g.state)">
				<button
					type="button"
					class="apn-chip"
					*ngFor="let p of g.numbers"
					[class.apn-chip-free]="p.available"
					[class.apn-chip-taken]="!p.available"
					[class.apn-chip-selected]="p.phone_number_id === selectedId"
					[disabled]="!p.available"
					[title]="chipTitle(p)"
					(click)="pick(p)"
				>
					{{ p.phone_number }}
				</button>
			</div>
		</div>
	</div>
</div>
